// Fetch list

export const FETCH = 'borderCrossings.FETCH'
export const FETCH_STARTED = 'borderCrossings.FETCH_STARTED'
export const FETCH_FULFILLED = 'borderCrossings.FETCH_FULFILLED'
export const FETCH_REJECTED = 'borderCrossings.FETCH_REJECTED'
export const FETCH_CANCELLED = 'borderCrossings.FETCH_CANCELLED'

export const SORTING_CHANGED = 'borderCrossings.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'borderCrossings.FETCH_ONE'
export const FETCH_ONE_STARTED = 'borderCrossings.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'borderCrossings.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'borderCrossings.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'borderCrossings.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'borderCrossings.SAVE'
export const SAVE_STARTED = 'borderCrossings.SAVE_STARTED'
export const SAVE_FULFILLED = 'borderCrossings.SAVE_FULFILLED'
export const SAVE_REJECTED = 'borderCrossings.SAVE_REJECTED'
export const SAVE_CANCELLED = 'borderCrossings.SAVE_CANCELLED'

// Delete

export const DELETE = 'borderCrossings.DELETE'
export const DELETE_STARTED = 'borderCrossings.DELETE_STARTED'
export const DELETE_FULFILLED = 'borderCrossings.DELETE_FULFILLED'
export const DELETE_REJECTED = 'borderCrossings.DELETE_REJECTED'
export const DELETE_CANCELLED = 'borderCrossings.DELETE_CANCELLED'

// Find countries
export const FIND_COUNTRIES = 'borderCrossings.FIND_COUNTRIES'
export const FIND_COUNTRIES_STARTED = 'borderCrossings.FIND_COUNTRIES_STARTED'
export const FIND_COUNTRIES_FULFILLED = 'borderCrossings.FIND_COUNTRIES_FULFILLED'
export const FIND_COUNTRIES_REJECTED = 'borderCrossings.FIND_COUNTRIES_REJECTED'
export const FIND_COUNTRIES_CANCELLED = 'borderCrossings.FIND_COUNTRIES_CANCELLED'
